<script setup>
import { computed, getCurrentInstance } from 'vue';
import AttachmentDropzone from '../../common/AttachmentDropzone.vue';

const props = defineProps({
    options: {
        type: Object,
        default: () => ({})
    }
});

const emit = defineEmits(['hide-modal']);

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const modalTitle = computed(() => props.options.modalTitle || 'Bulk Upload');

// --- Methods ---

/**
 * Callback triggered by AttachmentDropzone whenever a file finishes uploading.
 * It identifies the current active view (e.g., 'files_list') and schedules
 * a data reload so the user sees the newly uploaded items immediately.
 */
const setFile = (obj) => {
    const viewId = store.state.mainViewId;
    if (viewId) {
        store.dispatch(`${viewId}/scheduleLoad`);
    }
};
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ modalTitle }}</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    @click="$emit('hide-modal')"
                ></button>
            </div>

            <div class="modal-body">
                <AttachmentDropzone
                    :set-file="setFile"
                    :multiple="true"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Optional: ensure the dropzone has enough height inside the modal */
.modal-body {
    min-height: 200px;
}
</style>